import * as React from 'react';
import { FormGroup, Input } from '../../../components/Bootstrap';
import { FufillmentCentersQuery_deliveryConfigurations } from '../__generated__/FufillmentCentersQuery';
import { CenterModel } from '../types';

interface DeliverySetupSelectorProps {
  data: CenterModel;
  onChange(data: CenterModel);
  deliveryConfigurations: FufillmentCentersQuery_deliveryConfigurations[];
}

export const DeliverySetupSelector: React.FC<DeliverySetupSelectorProps> = ({
  data,
  onChange,
  deliveryConfigurations,
}) => {
  const onChangeSelect: React.ChangeEventHandler<HTMLSelectElement> = React.useCallback(
    (e) => {
      onChange({
        ...data,
        deliveryConfigurationId: e.target.value,
      });
    },
    [onChange, data]
  );

  const current = deliveryConfigurations.find((d) => d.id === data.deliveryConfigurationId);

  return (
    <FormGroup className='fulfillment-center-modal-input noble-custom-select'>
      <Input type='select' value={data.deliveryConfigurationId} onChange={onChangeSelect} required={true}>
        {deliveryConfigurations.map((deliveryConfiguration) => (
          <option key={deliveryConfiguration.id} value={deliveryConfiguration.id}>
            {deliveryConfiguration.name}
          </option>
        ))}
      </Input>
      {current && <p className='mt-4 text-muted'>{current.description}</p>}
    </FormGroup>
  );
};
